<template>
  <section class="section">
    <h2 class="center">{{ content.title }}</h2>
    <p class="paragraph center mt-16">{{ content.description }}</p>
    <div class="flex__wrap value__list">
      <IconCard :content="item" v-for="item in content.items" :key="item.flexKey" />
    </div>
  </section>
</template>

<script>
import IconCard from '@/components/cards/IconCard.vue'

export default {
  name: 'IconCardsSection',
  components: { IconCard },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
